<template>
  <div class="question-field" :style="{ ...question.cssStyle, ...setPosition() }">
    <slot name="question-img"></slot>
    <div class="question-box">
      <div
        class="question-aduio"
        @mouseenter="iconHover = true"
        @mouseleave="iconHover = false"
        v-if="question.audio"
        @click="controllAudio()"
      >
        <transition name="icon-fade">
          <img draggable="false" v-if="canIPlayASong" :src="titleIcon" />
        </transition>
        <transition name="icon-fade">
          <img draggable="false" v-if="!canIPlayASong || iconHover" :src="titleIconOn" />
        </transition>
      </div>
      <div style="margin-left: 20px">
        <span v-html="question.question"></span>
      </div>
    </div>
    <div>
      <div class="mb-test-answers" v-if="this.borderActive">
        <div
          class="mb-test-answer"
          :style="[
            ans.cssStyle,
            { width: ans.width + 'px', height: ans.height + 'px', transition: '.5s' },
            ans.state == 'set' && question.block != true && !borderActiveStatus
              ? { background: '#cfd1d4', border: '7px solid #3677b9' }
              : {},
            ans.state == 'set' && question.block == true && !borderActiveStatus
              ? { color: '#ffffff', background: '#3677b9' }
              : {},
            ans.state == 'set' && question.correct == ansIndex && borderActiveStatus
              ? { color: '#ffffff', background: '#3677b9' }
              : {},
            ans.state == 'set' && question.correct != ansIndex && borderActiveStatus ? { background: '#cfd1d4' } : {},
            ans.state == 'unset' ? { background: '#cfd1d4' } : {},
          ]"
          v-for="(ans, ansIndex) in answers"
          @click="setStateAnwerWithBorder(ansIndex)"
          :key="'question-list-' + ansIndex"
        >
          <span v-if="textStatus" v-html="ans.text"></span>
          <span v-if="question.textOnClick && ans.state != 'unset'" v-html="question.textOnClick"></span>
        </div>
      </div>
      <div class="mb-test-answers" v-if="!this.borderActive">
        <div
          class="mb-test-answer"
          :style="[
            ans.cssStyle,
            { width: ans.width + 'px', height: ans.height + 'px', transition: '.5s' },
            ans.state == 'set' && question.correct == ansIndex ? { background: '#00ff00' } : {},
            ans.state == 'set' && question.correct != ansIndex ? { background: '#fe0a02' } : {},
            ans.state == 'unset' ? { background: 'rgb(170, 214, 255)' } : {},
          ]"
          v-for="(ans, ansIndex) in answers"
          @click="setState(ansIndex)"
          :key="'question-list-' + ansIndex"
        >
          <span v-if="textStatus" v-html="ans.text"></span>
          <span v-if="question.textOnClick && ans.state != 'unset'" v-html="question.textOnClick"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import defaultMixin from '../../../mixins/defaultMixin';
import _ from 'lodash';
import { Howler } from 'howler';
export default {
  name: 'mb-test-question',
  components: {},
  mixins: [defaultMixin],
  props: {
    borderActive: {
      //czy ma byc aktywna rameczka czy ten Mateusza badziewny zielony/czerwony (fujka)
      type: Boolean,
      default: function () {
        return false;
      },
    },
    borderActiveStatus: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    audioData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    gameStatus: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    question: {
      type: Object,
      default: function () {
        return {};
      },
    },
    textStatus: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  data() {
    return {
      answers: [],
      audio: null,
      canIPlayASong: true,
      iconHover: false,
      audioClick: null,
    };
  },
  beforeMount() {
    this.init();
  },
  // watch: {
  //   question: {
  //     handler: function(newValue) {
  //       console.log('Person with ID:' + newValue + ' modified');
  //     },
  //     deep: true,
  //   },
  // },

  methods: {
    setPosition() {
      if (this.question.pos) {
        return { position: 'absolute', left: this.question.pos.x + 'px', top: this.question.pos.y + 'px' };
      } else return {};
    },
    controllAudio() {
      if (this.audio) {
        if (this.audio.playing()) {
          this.audio.stop();
        } else {
          Howler.stop();
          this.audio.play();
        }
      }
    },
    init() {
      if (this.audioData.click) {
        this.audioClick = new Howl({
          src: this.giveMeImagePlease(this.audioData.click),
          autoplay: false,
          loop: false,
          volume: 0.5,
        });
      }
      this.answers = this.question.answers;
      if (this.question.audio) {
        this.audio = new Howl({
          src: this.giveMeImagePlease(this.question.audio),
          autoplay: false,
          loop: false,
          volume: 0.5,
          onend: () => {
            this.canIPlayASong = true;
          },
          onstop: () => {
            this.canIPlayASong = true;
          },
          onplay: () => {
            this.canIPlayASong = false;
          },
        });
      }
    },
    setState(ansIndex) {
      // console.log('setState', this.gameStatus);
      if (!this.gameStatus) {
        if (this.audioClick) this.audioClick.play();
        let it = this.answers[ansIndex];
        if (it.state == 'set') {
          it.state = 'unset';
        } else if (it.state == 'unset') {
          it.state = 'set';
        }
        this.$set(this.answers, ansIndex, it);
        if (!this.borderActive) {
          this.$emit('checkTest');
        }
        console.log(this.answers);
      }
    },
    setStateAnwerWithBorder(ansIndex) {
      if (!this.question.block) {
        // console.log('setState', this.gameStatus);
        if (!this.gameStatus) {
          if (this.audioClick) this.audioClick.play();
          let it = this.answers[ansIndex];
          if (it.state == 'set') {
            it.state = 'unset';
          } else if (it.state == 'unset') {
            this.answers.forEach((elAns) => {
              if (elAns.state == 'set') {
                elAns.state = 'unset';
              }
            });
            it.state = 'set';
          }
          this.$set(this.answers, ansIndex, it);
          if (!this.borderActive) {
            this.$emit('checkTest');
          }
          console.log(this.answers);
        }
      }
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  beforeDestroy() {},
  computed: {
    titleIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/title-64px.png`);
      } catch {
        console.log(
          '%cTitleIcon MbTestQuestion- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    titleIconOn() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/title-on-64px.png`);
      } catch {
        console.log(
          '%cTitleIconOn MbTestQuestion- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    backgroundImageUrl() {
      return 'static/' + this.this.background;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 1030px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0

.question-field
  text-align: left
  margin: 10px
  padding: 0px 10px
  background: white
  border-radius: 10px
  display: flex
  align-items: center
  justify-content: space-between
  box-shadow: 0 0 3px 1px rgba(0,0,0,0.3)
  .question-box
    display: flex
    align-items: center
    justify-content: flex-start
    .question-aduio
      width: 48px
      height: 48px
      position: relative
      margin-left: 20px
      // background: red
      img
        position: absolute
        top: 0
        left: 0
        // transition: .5s
        cursor: pointer
.mb-test-answers
  display: flex
  align-items: center
  justify-content: center
    // border-radius: 10px
  .mb-test-answer
    border-radius: 10px
    margin: 10px
    width: 100px
    height: 100px
    background: rgb(170, 214, 255)
    display: flex
    align-items: center
    cursor: pointer
    justify-content: center
    box-shadow: 0 0 3px 1px rgba(0,0,0,0.3)
      // .mb-test-answer-correct
      // bacground:rgb(0,255,0)
      // .mb-test-answer-incorrect
      // background:rgb(255,0,0)

.img-fade-leave-active, .img-fade-enter-active
  transition: all .5s linear
.img-fade-leave-to, .img-fade-enter
  opacity: 0
.img-check-fade-leave-active
  transition: all .1s .5s linear
.img-check-fade-enter-active
  transition: all .3s linear
.img-check-fade-leave-to, .img-check-fade-enter
  opacity: 0
.icon-fade-leave-active, .icon-fade-enter-active
  transition: all .5s linear
.icon-fade-leave-to, .icon-fade-enter
  opacity: 0
</style>
